import { FC } from 'react'

import { View } from '@react-pdf/renderer'

const Border: FC = () => <View style={{ height: 1, backgroundColor: '#E2E2E5' }} />

export default Border
